// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__5AWw4","title":"Advt_title__9rZaA","wiggle":"Advt_wiggle__J7TyL","qrsWrapper":"Advt_qrsWrapper__5T37F","qrCode":"Advt_qrCode__5zuAi"};